module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "now-marker",
    style: ({
      top: _vm.top + 'px'
    })
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49ad9ab0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/Mobile/DayCal/NowIndicator.vue
// module id = 1624
// module chunks = 1